import {SvgIcon} from "@material-ui/core";

export const CustomLogoutIcon = (props) => {
    return (
        <SvgIcon viewBox="0 0 25 25" fill="#76808A" {...props}>
            <path d="M5.14819 5.53271H11.1482C11.6982 5.53271 12.1482 5.08271 12.1482 4.53271C12.1482 3.98271 11.6982 3.53271 11.1482 3.53271H5.14819C4.04819 3.53271 3.14819 4.43271 3.14819 5.53271V19.5327C3.14819 20.6327 4.04819 21.5327 5.14819 21.5327H11.1482C11.6982 21.5327 12.1482 21.0827 12.1482 20.5327C12.1482 19.9827 11.6982 19.5327 11.1482 19.5327H5.14819V5.53271Z"/>
            <path d="M20.7982 12.1827L18.0082 9.39271C17.6882 9.07271 17.1482 9.29272 17.1482 9.74271V11.5327H10.1482C9.59819 11.5327 9.14819 11.9827 9.14819 12.5327C9.14819 13.0827 9.59819 13.5327 10.1482 13.5327H17.1482V15.3227C17.1482 15.7727 17.6882 15.9927 17.9982 15.6727L20.7882 12.8827C20.9882 12.6927 20.9882 12.3727 20.7982 12.1827Z"/>
        </SvgIcon>
    )
}
